import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import ProcurementTable from "./ProcurementTable";
import btnDownloadIcon from "../../../Assests/download-icon.svg";
import btnSaveIcon from "../../../Assests/Save-btn.svg";
import {
  EditProductTableSuccess,
  ViewProductTableError,
  ViewProductTableStart,
  ViewProductTableSuccess,
  enableEditFilter,
  loadCascadeOptions,
} from "../../../Redux/Actions/InputData";
import { postRequest, putRequest } from "../../../Services/AxiosConfiguration";
import {
  API_BASE_URL,
  BULK_EDIT_MANUFACTURING_MASTER_TABLE_API,
  DISPLAY_MANUFACTURING_MASTER_1_TABLE_API,
  DOWNLOAD_MANUFACTURING_MASTER_1_TABLE_API,
  LONG_FACILITY_MASTER_GET_API,
  LONG_PROCUREMENT_DOWNLOAD_API,
  LONG_PROCUREMENT_GET_API,
  LONG_PROCUREMENT_UPDATE_DATA_API,
  VIEW_MANUFACTURING_MASTER_1_TABLE_API,
} from "../../../Utils/Config";
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
import axios from "axios";
import FileSaver from "file-saver";
import "./style.css";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import Snackbar from "@mui/material/Snackbar";
import Alert, { AlertProps } from "@mui/material/Alert";
import AddRowButton from "../../../Components/Common/AddRowButton";
import DeleteRowsButton from "../../../Components/Common/DeleteRowsButton";
import ConfirmationDialog from "../../../Components/Common/ConfirmationDialog";

function Procurement(props: any) {
  const childRef: any = useRef();
  const dispatch: any = useDispatch();
  const [selectVendorCode, setSelectVendorCode] = useState<any>("");
  const [selectCode, setSelectCode] = useState<any>("");
  const [selectVendorDescription, setSelectVendorDescription] =
    useState<any>("");
  const [selectType, setSelectType] = useState<any>("");
  const [rowsData, setRows] = React.useState<any[]>([]);
  const [isProcessed, setIsProcessed] = React.useState(false);
  const [vendorCodeOptions, setVendorCodeOptions] = React.useState([]);
  const [codeOptions, setCodeOptions] = useState<any>([]);
  const [vendorDescriptionOptions, setVendorDescriptionOptions] = useState<any>(
    [],
  );
  const [typeOptions, setTypeOptions] = useState<any>([]);
  const [getEditedValue, setEditedValue] = useState<any>([]);
  const [descriptionOptions, setDescriptionOptions] = useState<any>([]);
  const [selectDescription, setSelectDescription] = useState<any>("");
  const [timePeriodOptions, setTimePeriodOptions] = useState<any>([]);
  const [selectTimePeriod, setSelectTimePeriod] = useState<any>("");
  const [open, setOpen] = React.useState(false);

  const [filterRequest, setFilterRequest] = React.useState([
    { key: "vendor_Code", value: "" },
    { key: "vendor_Description", value: "" },
    { key: "rM_PM_MI_Type", value: "" },
    { key: "rM_PM_MI_Code", value: "" },
    { key: "rM_PM_MI_Description", value: "" },
    { key: "time_Period", value: "" },
  ]);

  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [deletedRows, setDeletedRows] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [isActionEnabled, setIsActionEnabled] = useState(false);
  const handleSelectionChange = (newSelection: any[]) => {
    setSelectedRows(newSelection);
    setIsActionEnabled(newSelection.length > 0);
  };

  const sortedVendorCode = vendorCodeOptions?.sort((a: any, b: any) =>
    a?.vendor_Code.localeCompare(b?.vendor_Code),
  );

  const sortedTypeNames = typeOptions?.sort((a: any, b: any) =>
    a?.rM_PM_MI_Type.localeCompare(b?.rM_PM_MI_Type),
  );

  var vcode = 0;
  var vDescription = 0;
  var type = 0;
  var code = 0;
  var description = 0;
  var time = 0;

  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId,
  );
  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId,
  );

  /**Redux state */
  const selectedUsecaseeId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId,
  );
  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId,
  );

  const selectedScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedScenarioId,
  );

  const isEditPopup = useSelector(
    (state: any) => state.InputDataReducers.editPopupFlage,
  );
  const selectedTimePeriodData = useSelector(
    (state: any) => state.InputDataReducers.selectedTimePeriodData,
  );

  const handleChangeSelectVendorCode = (event: any) => {
    setSelectType("");
    setSelectCode("");
    setSelectDescription("");
    setSelectVendorDescription("");
    setSelectTimePeriod("");
    filterRequest[1].value = "";
    filterRequest[3].value = "";
    filterRequest[2].value = "";
    filterRequest[4].value = "";
    filterRequest[5].value = "";
    const {
      target: { value },
    } = event;
    setSelectVendorCode(value);
    filterRequest[0].value = value;
    callTableGridApi();
    vcode = 1;
    vDescription = 0;
    type = 0;
    code = 0;
    description = 0;
    time = 0;
  };

  // need to change these values
  const handleAddRow = () => {
    setRows((prev: any) => {
      const emptyRow = {
        id: new Date().getTime(),
        folder_Id: selectedFolderId,
        scenario_id: selectedScenarioId,
        vendor_Code: "",
        vendor_Description: "",
        rM_PM_MI_Type: "",
        rM_PM_MI_Code: "",
        rM_PM_MI_Description: "",
        time_Period: 0,
        min_Capacity: 0,
        max_Capacity: "",
        procurement_Cost_per_Tonne: "",
        lead_Time: "",
        cO2: "",
        isNew: true,
      };
      return prev.length > 0 ? [...prev, emptyRow] : prev;
    });
  };
  const handleChangeSelectVendorDescription = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectVendorDescription(value);
    filterRequest[1].value = value;
    callTableGridApi();
    vcode = 1;
    vDescription = 1;
    type = 0;
    code = 0;
    description = 0;
    time = 0;
    setSelectType("");
    setSelectCode("");
    setSelectDescription("");
    setSelectTimePeriod("");
    filterRequest[3].value = "";
    filterRequest[2].value = "";
    filterRequest[4].value = "";
    filterRequest[5].value = "";
  };

  const handleChangeSelectType = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectType(value);
    filterRequest[2].value = value;
    callTableGridApi();
    vcode = 1;
    vDescription = 1;
    type = 1;
    code = 0;
    description = 0;
    time = 0;
    setSelectCode("");
    setSelectDescription("");
    setSelectTimePeriod("");
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    filterRequest[5].value = "";
    filterRequest[3].value = "";
  };

  const handleChangeSelectCode = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectCode(value);
    filterRequest[3].value = value;
    callTableGridApi();
    vcode = 1;
    vDescription = 1;
    type = 1;
    code = 1;
    description = 0;
    time = 0;
    setSelectDescription("");
    setSelectTimePeriod("");
    filterRequest[4].value = "";
    filterRequest[5].value = "";
  };

  const handleChangeSelectDescription = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectDescription(value);
    filterRequest[4].value = value;
    callTableGridApi();
    vcode = 1;
    vDescription = 1;
    type = 1;
    code = 1;
    description = 1;
    time = 0;
    setSelectTimePeriod("");
    filterRequest[5].value = "";
  };

  const handleChangeSelectTimePeriod = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectTimePeriod(value);
    filterRequest[5].value = value;
    callTableGridApi();
    vcode = 1;
    vDescription = 1;
    type = 1;
    code = 1;
    description = 1;
    time = 1;
  };

  const handleDownload = (e: any) => {
    downloadXLSFile();
  };

  const downloadXLSFile = async () => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    const requestParam = {
      usecaseId: 0,
      category_id: 0,
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
      table: "tblScenario_RMPMMIProcurement_LT",
      time_period: "string",
      filter: filterList,
    };
    // const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblManufacturing1Data", "filter": filterList };
    const urls = API_BASE_URL + LONG_PROCUREMENT_DOWNLOAD_API;
    axios({
      url: urls,
      method: "post",
      responseType: "arraybuffer",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver(blob, Date.now() + ".xlsx");
    });
  };

  useEffect(() => {
    callTableGridApi();
  }, [
    selectedUsecaseId,
    selectedCategoryId,
    selectedFolderId,
    selectedScenarioId,
    selectedTimePeriodData,
  ]);
  const callTableGridApi = (resetfilter?: any) => {
    let timePeriodValues =
      selectedTimePeriodData !== undefined &&
      selectedTimePeriodData &&
      selectedTimePeriodData !== "Time Period" &&
      selectedTimePeriodData?.length > 0 &&
      selectedTimePeriodData[0] !== "Time Period" &&
      selectedTimePeriodData !== ""
        ? selectedTimePeriodData.join(",")
        : "";
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId
        : selectedScenarioId;
    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table: "tblScenario_RMPMMIProcurement_LT",
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: filterList,
      time_period: timePeriodValues,
    };

    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + LONG_PROCUREMENT_GET_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          setIsProcessed(true);
          console.log(response.data, requestParam, "basepack2");
          setRows(response.data);
          if (vDescription === 0) {
            setVendorDescriptionOptions(
              loadVendorDescriptionOptions(response.data),
            );
          }
          if (vcode === 0)
            setVendorCodeOptions(loadFactoryOptions(response.data));
          if (type === 0) {
            setTypeOptions(loadTypeOptions(response.data));
          }
          if (code === 0) {
            setCodeOptions(loadCodeOptions(response.data));
          }
          if (description === 0) {
            setDescriptionOptions(loadDescriptionOptions(response.data));
          }
          if (time === 0) {
            setTimePeriodOptions(loadTimePeriodOptions(response.data));
          }
          dispatch(ViewProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  const loadFactoryOptions = (data: any) => {
    const vendorCodeOptions: any = [];
    data.map((item: any) => {
      const filteredItem = vendorCodeOptions.find((obj: any) => {
        return obj.vendor_Code === item.vendor_Code;
      });
      if (filteredItem === undefined || filteredItem == null) {
        vendorCodeOptions.push({ id: item.id, vendor_Code: item.vendor_Code });
      }
    });
    return vendorCodeOptions;
    //setVendorCodeOptions(vendorCodeOptions);
  };

  const loadDescriptionOptions = (data: any) => {
    const descriptionOptions: any = [];
    data.map((item: any) => {
      const filteredItem = descriptionOptions.find((obj: any) => {
        return obj.rM_PM_MI_Description === item.rM_PM_MI_Description;
      });
      if (filteredItem === undefined || filteredItem == null) {
        descriptionOptions.push({
          id: item.id,
          rM_PM_MI_Description: item.rM_PM_MI_Description,
        });
      }
    });
    return descriptionOptions;
    //setVendorCodeOptions(vendorCodeOptions);
  };

  const loadTimePeriodOptions = (data: any) => {
    const timePeriodOptions: any = [];
    data.map((item: any) => {
      const filteredItem = timePeriodOptions.find((obj: any) => {
        return obj.time_Period === item.time_Period;
      });
      if (filteredItem === undefined || filteredItem == null) {
        timePeriodOptions.push({ id: item.id, time_Period: item.time_Period });
      }
    });
    return timePeriodOptions;
  };

  const loadVendorDescriptionOptions = (data: any) => {
    const vendorDescriptionOptions: any = [];
    data.map((item: any) => {
      const filteredItem = vendorDescriptionOptions.find((obj: any) => {
        return obj.vendor_Description === item.vendor_Description;
      });
      if (filteredItem === undefined || filteredItem == null) {
        vendorDescriptionOptions.push({
          id: item.id,
          vendor_Description: item.vendor_Description,
        });
      }
    });
    return vendorDescriptionOptions;
  };

  const loadCodeOptions = (data: any) => {
    console.log(data, "basepack");
    const codeOptions: any = [];
    data.map((item: any) => {
      const filteredItem = codeOptions.find((obj: any) => {
        return obj.rM_PM_MI_Code === item.rM_PM_MI_Code;
      });
      if (filteredItem === undefined || filteredItem == null) {
        codeOptions.push({ id: item.id, rM_PM_MI_Code: item.rM_PM_MI_Code });
      }
    });
    return codeOptions;
  };

  const loadTypeOptions = (data: any) => {
    const typeOptions: any = [];
    data.map((item: any) => {
      const filteredItem = typeOptions.find((obj: any) => {
        return obj.rM_PM_MI_Type === item.rM_PM_MI_Type;
      });
      if (filteredItem === undefined || filteredItem == null) {
        typeOptions.push({ id: item.id, rM_PM_MI_Type: item.rM_PM_MI_Type });
      }
    });
    return typeOptions;
  };

  const getfiltersApi = () => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId?.scenario_id
        : selectedScenarioId;
    const requestParam = {
      usecaseId: selectedUsecaseeId,
      category_id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table: "tblScenario_RMPMMIProcurement_LT",
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: filterList,
      time_period: "",
    };

    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + LONG_PROCUREMENT_GET_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          console.log(response.data, "response");
          setIsProcessed(true);
          console.log(response.data, requestParam, "basepack2");
          setRows(response.data);
          setVendorCodeOptions(loadFactoryOptions(response.data));
          setCodeOptions(loadCodeOptions(response.data));
          setDescriptionOptions(loadDescriptionOptions(response.data));
          setVendorDescriptionOptions(
            loadVendorDescriptionOptions(response.data),
          );
          setTypeOptions(loadTypeOptions(response.data));
          setTimePeriodOptions(loadTimePeriodOptions(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  useEffect(() => {
    // callTableGridApi();
    getfiltersApi();
  }, [selectedFolderId, selectedScenarioId]);

  const handleRestoreClicked = (e: any) => {
    setSelectVendorCode("");
    setSelectCode("");
    setSelectDescription("");
    setSelectTimePeriod("");
    setSelectVendorDescription("");
    setSelectType("");
    filterRequest[0].value = "";
    filterRequest[1].value = "";
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    filterRequest[5].value = "";
    vcode = 0;
    vDescription = 0;
    type = 0;
    code = 0;
    description = 0;
    time = 0;
    callTableGridApi([]);
  };

  // bulk edit

  const handleClearEditData = (val: any) => {
    console.log(val, "edited array");
  };

  const isEditEnabled = useSelector(
    (state: any) => state.InputDataReducers.editFilterEnable,
  );

  const handleFetchEditData = (val: any) => {
    console.log(val, "edited array");
    setEditedValue(val);
  };

  const handleEditSave = (e: any) => {
    const requiredFields = [
      "vendor_Code",
      "vendor_Description",
      "rM_PM_MI_Type",
      "rM_PM_MI_Code",
      "rM_PM_MI_Description",
      "time_Period",
      "min_Capacity",
      "max_Capacity",
      "procurement_Cost_per_Tonne",
      "lead_Time",
      "cO2",
    ];
    const allMissingFields = new Set<string>();
    getEditedValue.forEach((row: any) => {
      requiredFields.forEach((field) => {
        const value = row[field];
        if (value === undefined || value === null || value === "") {
          // Convert field name to readable format
          const fieldName = field
            .replace(/_/g, " ")
            .replace(/\b\w/g, (l) => l.toUpperCase());
          allMissingFields.add(fieldName);
        }
      });
    });

    if (allMissingFields.size > 0) {
      // Convert Set to Array and join
      const missingFieldsList = Array.from(allMissingFields).join(", ");

      setSnackbar({
        children: `Please fill the required fields: ${missingFieldsList}`,
        severity: "error",
      });
      return; // Prevent the save operation
    }

    handleClickOpen();
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  //const urls = API_BASE_URL + BULK_EDIT_MANUFACTURING_MASTER_TABLE_API;
  const handleDeleteRows = () => {
    if (!selectedRows.length) return;
    setIsDeleteConfirmOpen(true);
  };

  const handleConfirmDeleteRows = () => {
    const updatedRows: any[] = [];
    const rowsToDelete: any[] = [];

    rowsData.forEach((row: any) => {
      if (selectedRows.includes(row.id)) {
        const updated = {
          ...row,
          folder_id: 0,
          folder_Id: 0,
          scenario_id: 0,
          isDelete: true,
        };
        rowsToDelete.push(updated);
      } else {
        updatedRows.push(row);
      }
    });

    setRows(updatedRows);

    if (rowsToDelete.length > 0) {
      // Store deleted rows separately
      setDeletedRows((prev: any[]) => [...prev, ...rowsToDelete]);

      setIsDeleteConfirmOpen(false);
      setSelectedRows([]);
      setIsActionEnabled(false);

      const dataToSave =
        getEditedValue && getEditedValue.length > 0
          ? [
              ...getEditedValue.filter(
                (row: any) => row && Object.keys(row).length > 0,
              ),
              ...rowsToDelete,
            ]
          : rowsToDelete;

      handleAgree(dataToSave, "Record deleted successfully");
    } else {
      setIsDeleteConfirmOpen(false);
    }
  };

  const handleAgree = (dataToSave: any[], successMessage: string) => {
    const transformedRows = dataToSave.map((row: any) => {
      if (row.isNew) {
        const { isNew, ...rest } = row;
        rest.id = 0;
        return rest;
      } else if (row.isDelete) {
        const { isDelete, ...rest } = row;
        rest.folder_id = 0;
        rest.Scenario_Id = 0;
        return rest;
      }

      return row;
    });
    const urls = API_BASE_URL + LONG_PROCUREMENT_UPDATE_DATA_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };

    putRequest(urls, { data: transformedRows }, header, {})
      .then((response) => {
        if (response.status == 200) {
          callTableGridApi();
          setSnackbar({
            children: successMessage,
            severity: "success",
          });
          handleClose();
          //dispatch(enableEditFilter(false, "handlecat"));
          childRef?.current?.ClearEditedData();
          dispatch(EditProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        setSnackbar({
          children: "Something went wrong please try again!",
          severity: "error",
        });
        // dispatch(enableEditFilter(false, "handlecat"));
        handleClose();
      });
    // setTimeout(() => {
    //   props?.onClose();
    // }, 200);
  };

  // bulk edit

  const [snackbar, setSnackbar] = React.useState<Pick<
    AlertProps,
    "children" | "severity"
  > | null>(null);

  const handleCloseSnackbar = () => setSnackbar(null);

  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        className="Dialogbox-display"
      >
        <DialogTitle
          id="responsive-dialog-title"
          className="responsive-dialog-title-txt"
        >
          {"Confirmation for Edit"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText className="md-alert-clr">
            {getEditedValue.length > 0
              ? "Do you want to submit the edited Procurement table data?"
              : "Please Edit any value to save!"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {getEditedValue.length > 0 ? (
            <>
              <Button className="modal-btn-b" autoFocus onClick={handleClose}>
                No
              </Button>
              <Button
                className="modal-btn-b"
                onClick={() =>
                  handleAgree(getEditedValue, "Successfully saved")
                }
                autoFocus
              >
                Yes
              </Button>
            </>
          ) : (
            <Button className="modal-btn-b" autoFocus onClick={handleClose}>
              Ok
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <ConfirmationDialog
        open={isDeleteConfirmOpen}
        onClose={() => setIsDeleteConfirmOpen(false)}
        onConfirm={handleConfirmDeleteRows}
        title="Confirmation for Delete"
        page="Shift And Changeover"
        confirmText="Yes"
        cancelText="No"
        fullScreen={fullScreen}
      />
      <div className="Compare">
        <div className="filter-section">
          <div className="page-title">
            <h3>RMPMMI Procurement</h3>
          </div>
          <div className="filters">
            <span title="Reset">
              <RestoreOutlinedIcon
                className="restoreIcon"
                onClick={(e) => handleRestoreClicked(e)}
              />
            </span>
            <AddRowButton
              isEditEnabled={isEditEnabled && !isActionEnabled}
              handleAddRow={handleAddRow}
            />
            <DeleteRowsButton
              isEditEnabled={isEditEnabled && isActionEnabled}
              handleDeleteRows={handleDeleteRows}
            />
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown ddoverlap-fix">
                {/* <InputLabel>Vendor Code</InputLabel> */}
                <Select
                  id="simple-select-1"
                  value={selectVendorCode}
                  placeholder="Select Vendor Code"
                  // renderValue={(selectVendorCode: any) => selectVendorCode}
                  onChange={handleChangeSelectVendorCode}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Vendor Code</em>
                  </MenuItem>
                  {vendorCodeOptions?.map((d: any) => {
                    // return (<MenuItem key={d} value={d.factory}>{d.factory}</MenuItem>)
                    return (
                      <MenuItem key={d} value={d.vendor_Code}>
                        {d.vendor_Code}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            {/* <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                <Select
                  id="simple-select-2"
                  value={selectVendorDescription}
                  placeholder="Select Vendor Description"
                  onChange={handleChangeSelectVendorDescription}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Vendor Description</em>
                  </MenuItem>
                  {vendorDescriptionOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.vendor_Description}>
                        {d.vendor_Description}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div> */}
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown ddoverlap-fix">
                {/* <InputLabel>Type</InputLabel> */}
                <Select
                  id="simple-select-3"
                  value={selectType}
                  placeholder="Select Line"
                  onChange={handleChangeSelectType}
                  // renderValue={(selectType: any) => selectType}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>RMPMMI Type</em>
                  </MenuItem>
                  {sortedTypeNames?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.rM_PM_MI_Type}>
                        {d.rM_PM_MI_Type}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown ddoverlap-fix">
                {/* <InputLabel>Code</InputLabel> */}
                <Select
                  id="simple-select-4"
                  value={selectCode}
                  placeholder="Select Basepack"
                  onChange={handleChangeSelectCode}
                  // renderValue={(selectCode: any) => selectCode}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>RMPMMI Code</em>
                  </MenuItem>
                  {codeOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.rM_PM_MI_Code}>
                        {d.rM_PM_MI_Code}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown ddoverlap-fix">
                {/* <InputLabel>Description</InputLabel> */}
                <Select
                  id="simple-select-4"
                  value={selectDescription}
                  placeholder="Select Basepack"
                  onChange={handleChangeSelectDescription}
                  // renderValue={(selectDescription: any) => selectDescription}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>RMPMMI Description</em>
                  </MenuItem>
                  {descriptionOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.rM_PM_MI_Description}>
                        {d.rM_PM_MI_Description}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown ddoverlap-fix">
                {/* <InputLabel>TimePeriod</InputLabel> */}
                <Select
                  id="simple-select-4"
                  value={selectTimePeriod}
                  placeholder="Select Basepack"
                  onChange={handleChangeSelectTimePeriod}
                  // renderValue={(selectTimePeriod: any) => selectTimePeriod}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>TimePeriod</em>
                  </MenuItem>
                  {timePeriodOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.time_Period}>
                        {d.time_Period}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>

            {isEditEnabled && isEditPopup && (
              <FormControl fullWidth>
                <div
                  className="content-save-btn"
                  onClick={(e) => handleEditSave(e)}
                >
                  <img src={btnSaveIcon} alt="" /> <span> Save</span>
                </div>
              </FormControl>
            )}

            <div className="filter-item">
              <FormControl fullWidth>
                <div
                  className="content-download-btn"
                  onClick={(e) => handleDownload(e)}
                >
                  <img src={btnDownloadIcon} alt="" /> <span> Download</span>
                </div>
              </FormControl>
            </div>
          </div>
        </div>
      </div>
      <div>
        <ProcurementTable
          ref={childRef}
          isProcessed={isProcessed}
          rowsData={rowsData}
          handleGetEditData={handleFetchEditData}
          handleClearEditData={handleClearEditData}
          setRows={setRows}
        />
        {!!snackbar && (
          <Snackbar
            open
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={handleCloseSnackbar}
            autoHideDuration={6000}
          >
            <Alert {...snackbar} onClose={handleCloseSnackbar} />
          </Snackbar>
        )}
      </div>
    </>
  );
}

export default Procurement;
